import { useEffect } from 'react';
import { overlayUrl } from '@dashboard/services/env';
import { injectTrackingScript } from '@/dashboard/lib/scriptInjector';

export default function useCheckoutEmbed() {
  useEffect(() => {
    const isLoaded = document.querySelector(`script[src="${overlayUrl}"]`);

    if (!isLoaded) {
      injectTrackingScript(`<script src="${overlayUrl}"></script>`);
    }
  }, []);
}
